module.exports = __webpack_public_path__ + "img/iot2.3d4609a5.png";